import {AppRoutesEnum} from '@src/Constant/routes';

const getPrefixedPattern = (routeEnum: AppRoutesEnum) => {
  return `/:lang?/app${routeEnum}`;
};

export default getPrefixedPattern;
